var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 89L252 89",
    stroke: "#FF3131",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 172H171",
    stroke: "#68ADE5",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102 130L232 130",
    stroke: "#93E54B",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286 53H80C74.4771 53 70 57.4772 70 63V286C70 291.523 74.4772 296 80 296H286C291.523 296 296 291.523 296 286V257H316V286C316 302.569 302.569 316 286 316H80C63.4315 316 50 302.569 50 286V63C50 46.4314 63.4315 33 80 33H286C302.569 33 316 46.4315 316 63V137.399C313 135.865 309.601 135 306 135C302.399 135 299 135.865 296 137.399V63C296 57.4771 291.523 53 286 53Z",
    fill: "#EA3377"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_84_33",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 236,
    y: 148,
    width: 139,
    height: 134
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.271 245.165L241.551 280.106C241.068 281.225 240.182 281.782 238.896 281.782C238.089 281.782 237.406 281.505 236.845 280.945C236.279 280.387 236 279.71 236 278.91C236 278.432 236.079 278.035 236.242 277.713L285.229 161.402C286.998 157.094 289.731 153.826 293.434 151.59L293.916 151.111C297.454 149.039 301.315 148 305.5 148C310.002 148 314.105 149.197 317.807 151.59L318.048 151.829H318.29C321.668 154.222 324.24 157.416 326.012 161.402L375 277.713V278.67C375 280.746 374.034 281.782 372.104 281.782C370.656 281.782 369.849 281.225 369.69 280.106L354.971 245.165H256.271Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_84_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 148H305.262V281.782H375V148Z",
    fill: "#FF005D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_84_33",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 236,
    y: 148,
    width: 139,
    height: 134
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.271 245.165L241.551 280.106C241.068 281.225 240.182 281.782 238.896 281.782C238.089 281.782 237.406 281.505 236.845 280.945C236.279 280.387 236 279.71 236 278.91C236 278.432 236.079 278.035 236.242 277.713L285.229 161.402C286.998 157.094 289.731 153.826 293.434 151.59L293.916 151.111C297.454 149.039 301.315 148 305.5 148C310.002 148 314.105 149.197 317.807 151.59L318.048 151.829H318.29C321.668 154.222 324.24 157.416 326.012 161.402L375 277.713V278.67C375 280.746 374.034 281.782 372.104 281.782C370.656 281.782 369.849 281.225 369.69 280.106L354.971 245.165H256.271Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_84_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.051 148H305.737V281.782H235.051V148Z",
    fill: "#BDEA88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.87e7dc165d8ef451da643b64b0c8639e.svg";
export { ForwardRef as ReactComponent };